var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrvtoContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "20px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffff",
    d: "M6.462 20h-.846q-.691 0-1.153-.462T4 18.384V12q0-1.664.626-3.118T6.34 6.34t2.542-1.714T12 4t3.118.626T17.66 6.34t1.714 2.542T20 12v6.385q0 .69-.462 1.152T18.384 20h-.846q-.67 0-1.143-.472q-.472-.472-.472-1.144v-2.922q0-.671.472-1.144t1.144-.472H19V12q0-2.925-2.037-4.962T12 5T7.038 7.038T5 12v1.846h1.462q.67 0 1.143.472q.472.472.472 1.143v2.923q0 .672-.472 1.144T6.46 20m0-5.154H5v3.539q0 .23.192.423t.423.192h.846q.27 0 .443-.173t.173-.442V15.46q0-.269-.173-.442t-.442-.173m10.461.616v2.923q0 .269.173.442t.443.173h.846q.23 0 .423-.192t.192-.424v-3.538h-1.461q-.27 0-.443.173t-.173.443m-10.461-.616h.615H5zm10.461 0H19z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrvtoContact);
export default __webpack_public_path__ + "static/media/trvto_contact.efef4635ee3d492d42c4bb8963a920b2.svg";
export { ForwardRef as ReactComponent };